import { AuthenticatedHttpService } from '@/shared/services/HttpService';

export class OrganizationService extends AuthenticatedHttpService {
  async createOrganization(name, maxUsers, maxGroups) {
    const httpClient = await this.client();
    const response = await httpClient.post('/organization/', {
      name,
      maxUsers,
      maxGroups,
    });

    return response.data;
  }

  async updateOrganization(organizationId, payload) {
    const httpClient = await this.client();
    await httpClient.put(`/organization/${organizationId}/`, payload);
  }

  async fetchOrganization(organizationId) {
    const httpClient = await this.client();
    const response = await httpClient.get(`/organization/${organizationId}`);
    return response.data;
  }

  async fetchOrganizations() {
    const httpClient = await this.client();
    const response = await httpClient.get('/organization/');
    return response.data.organizations;
  }

  async createUserInOrganization(organizationId, user) {
    const httpClient = await this.client();
    let response = await httpClient.post('/user', {
      user: {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        isAdmin: user.isAdmin,
      },
    });
    const userId = response.data;
    response = await this.addExistingUserToOrganization(organizationId, userId, user.groups, user.isAdmin);
    return response.data;
  }

  async updateUserInOrganization(organizationId, userId, user) {
    const httpClient = await this.client();
    const response = await httpClient.put(`/organization/${organizationId}/user/${userId}`, user);
    return response.data;
  }

  async addExistingUserToOrganization(organizationId, userId, groups, isAdmin) {
    const httpClient = await this.client();
    const response = await httpClient.post(`/organization/${organizationId}/user`, {
      userId,
      groups,
      isAdmin,
    });
    return response.data;
  }

  async fetchUsersInOrganization(organizationId) {
    const httpClient = await this.client();
    const response = await httpClient.get(`/organization/${organizationId}/users`);
    return response.data.users;
  }

  async fetchUserInOrganization(organizationId, userId) {
    const httpClient = await this.client();
    const response = await httpClient.get(`/organization/${organizationId}/user/${userId}`);
    return response.data;
  }

  async fetchGroupsInOrganization(organizationId) {
    const httpClient = await this.client();
    const response = await httpClient.get(`/organization/${organizationId}/groups`);
    return response.data.groups;
  }

  async deleteGroupFromOrganization(organizationId, groupId) {
    const httpClient = await this.client();
    await httpClient.delete(`/organization/${organizationId}/group/${groupId}`);
  }

  async deleteUserFromOrganization(organizationId, userId) {
    const httpClient = await this.client();
    await httpClient.delete(`/organization/${organizationId}/user/${userId}`);
  }

  async client() {
    const baseurl = `${process.env.VUE_APP_BACKEND_URL}/admin`;
    const httpClient = await this.prepareHttpClient(baseurl);

    return httpClient;
  }
}
